import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getLocalDateString } from '../../../../utils/dateUtils';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../css/CalendarFilter.css';

const CalendarFilter = ({ onDateChange, initialDate }) => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (initialDate) {
      setSelectedDate(new Date(initialDate));
    } else {
      setSelectedDate(null);
    }
  }, [initialDate]);

  const handleDateChange = (date) => {
    setSelectedDate(date);

    if (onDateChange) {
      let dateISO = '';
      if (date) {
        dateISO = getLocalDateString(date);
      }
      onDateChange(dateISO);
    }
  };

  return (
    <div className="calendar-filter">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        maxDate={new Date()}
        dateFormat="yyyy-MM-dd"
        className="date-search-input"
        placeholderText={t('admin.bookings.calendar_filter.placeholder')}
        isClearable={true}
      />
    </div>
  );
};

export default CalendarFilter;